import { render, staticRenderFns } from "./editNews.vue?vue&type=template&id=4623702b&"
import script from "./editNews.js?vue&type=script&lang=js&"
export * from "./editNews.js?vue&type=script&lang=js&"
import style0 from "../CreateNews/createNews.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports